import { once } from 'ramda';
import { UserSyncArguments } from 'user-sync/index.types';
import { getUserSyncURL } from './utils';

const ID = '65';
const IABids = [259];

export const createPixel = (gdprApplies?: boolean, tcString?: string | null): HTMLIFrameElement => {
  const iframe = document.createElement('iframe');
  const gdprData = gdprApplies && tcString ? `&gdpr=${gdprApplies}&gdpr_consent=${tcString}` : '';
  const redirect = `${getUserSyncURL(ID)}PARTNER_USER_ID`;

  iframe.style.display = 'none';
  iframe.src = `//visitor.omnitagjs.com/visitor/isync?uid=ebd167208cfac599416ddea5dbceb5dd&name=FUTURE_PLC&url=${redirect}${gdprData}`;
  return iframe;
};

export default once(({ userSyncPixelsManager, fastdom, context }: UserSyncArguments): void =>
  userSyncPixelsManager.create(context.gdprConsent, ID, IABids, () => {
    const iframe =
      context.gdprConsent.consent?.gdprApplies && context.gdprConsent.consent?.tcString
        ? createPixel(context.gdprConsent.consent.gdprApplies, context.gdprConsent.consent.tcString)
        : createPixel();

    fastdom.mutate(function userSyncOpenWebAddElement() {
      document.body.appendChild(iframe);
    });
  }),
);
